module.exports = __webpack_public_path__ + "img/recovery-passwordEN.91566f9c.png";